module.exports = __webpack_public_path__ + "img/one.54035734.jpg";